import React from 'react';
import './css/DiskPreview.css';
import { useImageContext } from '../contexts/ImageContext';
import { useDiskColor } from '../contexts/DiskColorContext';

const DiskPreview = ({ className }) => {
  const { currentImage } = useImageContext();
  const { diskColor } = useDiskColor();

  const classes = className || 'disk-display';

  return (
    <div className={classes} style={{ backgroundColor: diskColor }}>
      {currentImage ? (
        <img
          src={currentImage}
          alt="Uploaded Overlay"
          className="image-overlay"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
          onLoad={() => {
          }}
        />
      ) : (
        <div className="image-overlay" style={{ 
          background: 'rgba(255, 255, 255, 0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontSize: '14px'
        }}>
          No Image
        </div>
      )}
    </div>
  );
};

export default DiskPreview;
